const API_BASE = "/api";

async function postJson(path, payload) {
  const response = await fetch(`${API_BASE}${path}`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.detail || `Request failed (${response.status})`);
    error.detail = data.detail;
    throw error;
  }
  return data;
}

export const subscribeNewsletter = (payload) => postJson("/newsletter", payload);
export const submitContact = (payload) => postJson("/contact", payload);
